import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../services/api/axios";

const BASE = "/v1/admin/business/payouts";

// every merchant's payouts, with the partner that processed each
const fetchMerchantPayouts = async (params) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v !== undefined && v !== null)
  );
  const response = await api.get(BASE, { params: clean });
  return response.data;
};

export const useMerchantPayouts = (params) =>
  useQuery({
    queryKey: ["merchant-payouts", params],
    queryFn: () => fetchMerchantPayouts(params),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

// the partners, for the filter
export const usePayoutPartnersList = () =>
  useQuery({
    // not "payout-providers": the partner settings page caches a different shape under that key
    queryKey: ["merchant-payouts-partners"],
    queryFn: async () => {
      const { data } = await api.get("/v1/admin/business/payout-providers");
      const list = Array.isArray(data) ? data : data?.data ?? data?.result ?? [];
      return list;
    },
    refetchOnWindowFocus: false,
  });

const useAction = (mutationFn) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["merchant-payouts"] }),
  });
};

// ask the partner for the real status and apply it (never sends the payout again)
export const useRetryMerchantPayout = () =>
  useAction(async (uuid) => (await api.post(`${BASE}/${uuid}/retry`)).data);

export const useDeclineMerchantPayout = () =>
  useAction(async ({ uuid, reason }) => (await api.post(`${BASE}/${uuid}/decline`, { reason })).data);

export const useMarkMerchantPayoutSuccessful = () =>
  useAction(async ({ uuid, reason, providerReference }) =>
    (await api.post(`${BASE}/${uuid}/mark-successful`, { reason, ...(providerReference && { providerReference }) })).data
  );
